// Subscription status
export type SubscriptionStatus = 'active' | 'canceled' | 'past_due' | 'trialing';

// Subscription plan
export interface SubscriptionPlan {
  id: string;
  name: string;
  description?: string;
  monthlyPrice: number; // in cents
  annualPrice: number;  // in cents
  postLimit: number;
  workspaceLimit: number;
  teamMemberLimit: number;
  features: string[];
  reviewLimit: number;
  isActive: boolean;
}

// Usage metrics for current billing period
export interface UsageMetrics {
  postsGenerated: number;
  workspacesCreated: number;
  teamMembersAdded: number;
  reviewsUsed: number;
  postLimit: number;
  workspaceLimit: number;
  teamMemberLimit: number;
  reviewLimit: number;
}

